// src/utils/cotizacionCalculations.ts

import { getLineItemIvaRateFromDetails } from './orderFormUtils'

/**
 * Calcula los totales de la cotización
 * @param items - Array de items de la cotización
 * @param shippingValue - Valor del costo de envío como string
 * @param productDetails - Objeto con detalles de productos indexados por SKU o product_id
 * @returns Objeto con subtotal, descuento, impuestos, envío y total
 */
export function calculateTotals(
  items: any[] = [],
  shippingValue: string = '0',
  productDetails: { [key: string]: any } = {},
  clienteNeto: boolean = false
) {
  const subtotal = items.reduce((sum, item) => {
    return sum + (parseFloat(item.price || '0') * (item.quantity || 0))
  }, 0)
  
  const discount = items.reduce((sum, item) => {
    const d = item.discount !== undefined && item.discount !== null ? parseFloat(item.discount) : 0
    return sum + (isNaN(d) ? 0 : d)
  }, 0)
  
  const taxes = clienteNeto
    ? 0
    : items.reduce((sum, item) => {
        const itemSubtotal = parseFloat(item.price) * item.quantity
        const itemDiscount = item.discount !== undefined && item.discount !== null ? Number(item.discount) : 0
        const itemIva = getLineItemIvaRateFromDetails(item, productDetails)
        return sum + ((itemSubtotal - itemDiscount) * itemIva)
      }, 0)

  const shipping = parseFloat(shippingValue || '0')
  const total = subtotal - discount + taxes + shipping
  
  return {
    subtotal: subtotal.toFixed(2),
    discount: discount.toFixed(2),
    taxes: taxes.toFixed(2),
    shipping: shipping.toFixed(2),
    total: total.toFixed(2)
  }
}

